import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FaLinkedinIn, FaInstagram, FaYoutube } from "react-icons/fa";
import { FiMapPin, FiPhone, FiMail } from "react-icons/fi";
import { SITE, NAV } from "../../config/site";

export default function Footer() {
  const { t } = useTranslation();
  const year = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="blueprint-on-ink" />
      <div className="container wide">
        <div className="footer-top">
          <div className="footer-brand">
            <div className="fb-logo">
              <img src="/img/logo.png" alt={t("brand.full")} />
              <span className="wm"><b>D</b>EMA<b>R</b></span>
            </div>
            <p>{t("footer.blurb")}</p>
            <div className="footer-social">
              <a href={SITE.social.linkedin} target="_blank" rel="noopener noreferrer" aria-label="LinkedIn"><FaLinkedinIn /></a>
              <a href={SITE.social.instagram} target="_blank" rel="noopener noreferrer" aria-label="Instagram"><FaInstagram /></a>
              <a href={SITE.social.youtube} target="_blank" rel="noopener noreferrer" aria-label="YouTube"><FaYoutube /></a>
            </div>
          </div>

          <div className="footer-col">
            <h5>{t("footer.col_pages")}</h5>
            <ul>
              {NAV.map((item) => (
                <li key={item.to}><Link to={item.to}>{t(`nav.${item.key}`)}</Link></li>
              ))}
            </ul>
          </div>

          <div className="footer-col">
            <h5>{t("footer.col_services")}</h5>
            <ul>
              <li><Link to="/hizmetler#statik">{t("footer.svc_statik")}</Link></li>
              <li><Link to="/hizmetler#deprem">{t("footer.svc_deprem")}</Link></li>
              <li><Link to="/hizmetler#bim">{t("footer.svc_bim")}</Link></li>
              <li><Link to="/yazilimlar">{t("footer.svc_yazilim")}</Link></li>
              <li><a href="https://pusulaerp.com.tr/" target="_blank" rel="noopener noreferrer">{t("footer.pusula")}</a></li>
            </ul>
          </div>

          <div className="footer-col">
            <h5>{t("footer.col_contact")}</h5>
            <ul>
              <li className="contact-line"><FiMapPin style={{ verticalAlign: "-2px", marginRight: 8 }} />{t("footer.address")}</li>
              <li className="contact-line"><FiPhone style={{ verticalAlign: "-2px", marginRight: 8 }} /><a href={`tel:${SITE.phoneRaw}`}>{SITE.phone}</a></li>
              <li className="contact-line"><FiMail style={{ verticalAlign: "-2px", marginRight: 8 }} /><a href={`mailto:${SITE.email}`}>{SITE.email}</a></li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <span className="fm">© {year} {t("footer.rights")}</span>
          <span className="fm">{t("footer.madeWith")}</span>
        </div>
      </div>
    </footer>
  );
}
